const PageHero = {
  $: 'Stack',
  props: {
    direction: 'column',
    flexWrap: 'wrap',
    d: ['none', null, null, 'block'],
  },
  children: ({ primary = [], secondary = [] }) => [
    primary.length && {
      $: 'Flex',
      children: primary,
    },
    secondary.length && {
      $: 'Stack',
      children: secondary,
    },
  ],
};

export default PageHero;
